import fastStableStringify from '@wiko/fast-stable-stringify';
import { isJsonRpcPayload } from '@wiko/rpc-spec';

export function getWikoRpcPayloadDeduplicationKey(payload: unknown): string | undefined {
    return isJsonRpcPayload(payload) ? fastStableStringify([payload.method, payload.params]) : undefined;
}
